import { Block, Flex, Input, InputType, SizeProperty, Typography } from '@aloft/toolkit-sui';

import { Control, Controller, FieldValues, Path } from 'react-hook-form';

export const OrderDetailsInput = <TFieldValues extends FieldValues>({
  control,
  placeholderText,
  type = 'text',
  isRequired = false,
  width = '250px',
  name,
  label,
  errorMessage,
  onValueChange,
  isDisabled,
}: {
  control: Control<TFieldValues>;
  placeholderText?: string;
  type?: InputType | 'aloftPrice';
  isRequired?: boolean;
  width?: SizeProperty;
  name: Path<TFieldValues>;
  label: string;
  errorMessage?: string;
  onValueChange?: (value: unknown) => void;
  isDisabled?: boolean;
}) => (
  <Flex>
    <Block width="250px">
      <div style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
        <Typography variant="h4" color="textSecondary">
          {label}
        </Typography>
        {isRequired && <span style={{ color: 'red' }}> *</span>}
      </div>
    </Block>
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired,
      }}
      render={({ field, fieldState }) => {
        // Use form validation error if available, otherwise use custom validation error
        const formError = fieldState.error?.message;
        const customError = errorMessage;
        const hasError = formError || customError;

        return (
          <Block width={width}>
            <Input
              size="sm"
              type={type as any}
              placeholderText={placeholderText}
              isInvalid={!!hasError}
              {...field}
              onChange={(value: unknown) => {
                field.onChange(value);
                onValueChange?.(value);
              }}
              onClear={() => {
                if (type === 'aloftPrice' || type === 'aloftDate' || type === 'aloftArea') {
                  field.onChange(undefined);
                  onValueChange?.(undefined);
                  return;
                }
                field.onChange('');
                onValueChange?.('');
              }}
              isRequired={isRequired}
              isDisabled={isDisabled}
            />
            {!!hasError && (
              <Typography variant="body2" color="error">
                {formError || customError}
              </Typography>
            )}
          </Block>
        );
      }}
    />
  </Flex>
);
